<script setup>
const layout = useLayout()
const productResults = useProductResults()
</script>

<template>
  <div
    :class="{
      'site-header-container': true,
      'mobile-menu-active': layout.showMobileMenu,
    }"
  >
    <a href="#main" class="skip-link">Skip to main content.</a>
    <!-- Render promo banner as client-only to avoid it being cached -->
    <client-only>
      <div>
        <PromoBannerNew />
        <ProductEditBanner
          :user="$auth.user"
          :route="$route"
          :product="$store.getters.productObject"
        />
        <OccasionEditBanner
          :user="$auth.user"
          :route="$route"
          :occasion="productResults.thisOccasion"
        />
      </div>
    </client-only>
    <header id="site-header">
      <UtilityNavigation />
      <div class="rule"></div>
      <SiteNavigation @close-mobile-menu="layout.showMobileMenu = false" />
      <MobileSiteNavigation />
    </header>
  </div>
</template>
